import React from 'react';
import { css } from '@emotion/core';
import styled from '@emotion/styled';
import ButtonGroupButton from './Button';
import { hasInputControl, MaybeInputControl } from '../InputControl';

const ButtonLayout = styled.div`
  display: flex;

  &.wizard-button-group {
    flex-wrap: wrap;
    ${({ columns, gutter }) =>
      columns
        ? css`
            row-gap: ${gutter};
          `
        : ''}
  }

  & > * {
    flex: 1;
    flex-basis: 50px;
    min-width: 25px;
  }

  &.wizard-button-group > * {
    ${({ columns, gutter }) =>
      columns
        ? css`
            max-width: calc(${100 / columns}% - ${gutter});
            min-width: calc(${100 / columns}% - ${gutter});
          `
        : ''}
  }

  ${({ gutter }) => css`
    margin: 0 calc(-${gutter} / 2);
    & > * {
      margin: 0 calc(${gutter} / 2);
    }
  `}
`;

export default function ButtonGroup(props) {
  const {
    value: valueProp = null,
    options,
    onChange,
    error = null,
    disabled = null,
    button = <ButtonGroupButton />,
    gutter = '10px',
    className,
    columns,
    mode = 'default',
  } = props;
  const value =
    typeof valueProp === 'string'
      ? options.find((opt) => opt.value === valueProp) || null
      : valueProp;
  return (
    <MaybeInputControl {...props}>
      <ButtonLayout
        gutter={gutter}
        className={`${!hasInputControl(props) && className} ${
          mode === 'wizard' ? 'wizard-button-group' : ''
        }`}
        columns={columns}
        data-qa-value={value?.value}
      >
        {options.map((opt) =>
          React.cloneElement(button, {
            key: opt.value,
            option: opt,
            selected: Boolean(value && value.value === opt.value),
            error,
            disabled,
            onClick: (ev) => {
              if (onChange) onChange(opt, ev);
            },
          })
        )}
      </ButtonLayout>
    </MaybeInputControl>
  );
}
